import { filterSelectInput } from "components/form/DefaultConsultView/components/FilterInputs";
import Entity from "entity";
import firebaseUtil from "firebaseUtil";
import { format/*, formatISO, isValid, parseISO*/ } from "date-fns";
// import ValidatorHelper from "functions/ValidatorHelper";
import _ from 'lodash'
export default class User extends Entity {
    static get collectionUID() {
        // return "ValueCustomForm/MiMlzLA9SBqTZLPhCkDv/Values";
        return "PerfilUser";
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO").orderBy("nome");
    }

    static async getCurrent() {

        const uid = this.getCurrentUid();

        return await this.get(uid);
    }

    static getCurrentUid() {

        return firebaseUtil.getCurrentUser().uid;
    }

    static get labelField() {
        return "nome";
    }

    static get searchColumns() {
        return [

            // {
            //     field: "uid", headerName: "UID", flex: 1, filter: {

            //         compare: (value, row, filterValues) => {
            //             // if (value) {
            //             //     console.log('value', value)
            //             // let compareValue = value
            //             // if (optionsParse) {
            //             //     let indexOf = options.indexOf(value);
            //             //     compareValue = optionsParse[indexOf]
            //             // }


            //             // if (row.status === compareValue) {
            //             //     return true
            //             // }

            //             // return false
            //             // }
            //             // if (row.uid.length > 25) {
            //             //     return true
            //             // } else {
            //             //     return false
            //             // }
            //             return true
            //         }
            //     }
            // },

            // { field: "uid", headerName: "UID", flex: 1, filter: true },
            { field: "nome", headerName: "Nome", flex: 2, filter: true },
            { field: "email", headerName: "Email", flex: 2, filter: true },
            {
                field: "grupoPermissao.nome", headerName: "Grupo de Permissao", flex: 1, valueGetter: (v) => {

                    return _.get(v.row, "grupoPermissao.nome")
                },
            },
            {
                field: "status", headerName: "Status", flex: 1, filter: filterSelectInput("status", "Status", ["ATIVO", "INATIVO", "DELETAR"])
            },
            { field: "login_version", headerName: "APP_VERSION", flex: 1 },
            {
                field: "lastLogin", headerName: "Último Acesso", flex: 1, valueGetter: (v) => {

                    let date = v.row.lastLogin
                    if (v.row.lastLogin) {
                        date = date.toDate()
                        date = format(date, "dd/MM/yyy HH:mm");

                        return date
                    }


                    return ""
                }
            },

        ];
    }

    // static async validFieldErrors(values) {
    //     let v = new ValidatorHelper();
    //     v.addRequired('nome', "email");
    //     let errorsMessage = v.valid(values);

    //     if (errorsMessage.length) {
    //         return errorsMessage
    //     }

    //     return null
    // }
}
